import { render, staticRenderFns } from "./jobDetails.vue?vue&type=template&id=b7490fcc&scoped=true&"
import script from "./jobDetails.vue?vue&type=script&lang=js&"
export * from "./jobDetails.vue?vue&type=script&lang=js&"
import style0 from "./jobDetails.vue?vue&type=style&index=0&id=b7490fcc&prod&lang=scss&scoped=true&"
import style1 from "./jobDetails.vue?vue&type=style&index=1&id=b7490fcc&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7490fcc",
  null
  
)

export default component.exports